import { useState } from 'react';
import { useTranslation } from '../../i18n';
import analytics from '../../lib/analytics';

export function LanguagePicker() {
  const { language, setLanguage, t, direction } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'he', name: 'עברית' },
  ] as const;

  const handleLanguageChange = (lang: 'en' | 'he') => {
    if (lang !== language) {
      analytics.trackLanguageChanged(lang);
    }
    setLanguage(lang);
    setIsOpen(false);
  };

  const iconBtn: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '8px',
    transition: 'background 0.2s',
    color: '#64748b',
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={iconBtn}
        title={t('language_button_title') || 'Change language'}
        aria-label={t('language_button_title') || 'Change language'}
        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
        onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
      >
        <span className="material-symbols-outlined" style={{ fontSize: '22px' }}>
          language
        </span>
      </button>

      {isOpen && (
        <>
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 999,
            }}
            onClick={() => setIsOpen(false)}
          />
          <div
            style={{
              position: 'absolute',
              top: '60px',
              ...(direction === 'ltr' ? { left: '8px' } : { right: '8px' }),
              background: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              minWidth: '140px',
              overflow: 'hidden',
            }}
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                  padding: '10px 12px',
                  border: 'none',
                  background: language === lang.code ? '#eff6ff' : 'transparent',
                  color: language === lang.code ? '#1d4ed8' : '#475569',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: language === lang.code ? 600 : 500,
                  textAlign: 'left',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={(e) => {
                  if (language !== lang.code) {
                    e.currentTarget.style.background = '#f8fafc';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = language === lang.code ? '#eff6ff' : 'transparent';
                }}
              >
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontSize: '18px',
                    fontVariationSettings: language === lang.code ? "'FILL' 1" : "'FILL' 0",
                  }}
                >
                  check_circle
                </span>
                {lang.name}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}
